import ElementUI from 'element-ui'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Icon from 'vue-awesome/components/Icon.vue'
import './icons'
import VueScrollTo from 'vue-scrollto'
import Plugin from './plugin'
import router from './router'
import { plugin as SessionPlugin } from 'common/session'
import 'src/scss/style/index.scss'

Vue.config.productionTip = false
Vue.config.warnHandler = function (msg, vm, trace) {
  if (msg === 'Avoid using non-primitive value as key, use string/number value instead.') return
  console.warn(`[Vue warn]: ${msg}${trace}`)
}

Vue.use(ElementUI)
Vue.use(VueScrollTo)
Vue.use(Plugin)
Vue.use(SessionPlugin)
Vue.component('icon', Icon)

new Vue({
  el: '#app',
  router,
  render: h => h('router-view'),
})

if (process.env.NODE_ENV === 'development') {
  window.Vue = Vue
}



// WEBPACK FOOTER //
// ./src/main.js